import type {ActionWorkflowDefinition} from "./workflowModels";

const STORAGE_KEY = "parIntelligence_workflows_v4";

type StoredWorkflows = Record<string, ActionWorkflowDefinition>;

function loadAll(): StoredWorkflows {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? (JSON.parse(raw) as StoredWorkflows) : {};
    } catch {
        return {};
    }
}

function saveAll(workflows: StoredWorkflows): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(workflows));
}

export function loadWorkflow(id: string): ActionWorkflowDefinition | null {
    return loadAll()[id] ?? null;
}

export function saveWorkflow(definition: ActionWorkflowDefinition): void {
    const workflows = loadAll();
    workflows[definition.id] = definition;
    saveAll(workflows);
}

export function clearWorkflow(id: string): void {
    const workflows = loadAll();
    delete workflows[id];
    saveAll(workflows);
}
